import SupervisorLayout from '../../components/layout/SupervisorLayout';
import EventsListView from '../../components/EventsListView';

export default function SupervisorEventsListPage() {
  return (
    <SupervisorLayout>
      <EventsListView title="Events List" basePath="/supervisor/events-list" />
    </SupervisorLayout>
  );
}
